import { NewMessagesButton } from "@albertine/design-system/components/chat";
import { useAlbertineTranslation } from "albertine-shared-web";
import { useChatPage } from "../-hooks/useChatPage";
import { useChatUnread } from "../-hooks/useChatUnreadMessages";
import { useMessageJump } from "../-hooks/useMessageJump";
import { composerInsetTransition } from "../-utils/composerLayoutHeight";

export function ReturnFromJumpButton() {
    const t = useAlbertineTranslation();
    const { composerHeight } = useChatPage();
    const { hasUnreadMessages } = useChatUnread();
    const { returnMessageId, returnFromJump } = useMessageJump();

    // Shares its slot with the unread jump button, which is the more urgent prompt.
    if (!returnMessageId || hasUnreadMessages) {
        return null;
    }

    return (
        <NewMessagesButton
            className="absolute left-1/2 z-20 -translate-x-1/2"
            style={{
                bottom: composerHeight + 12,
                transition: composerInsetTransition("bottom"),
            }}
            onPress={returnFromJump}
        >
            {t("chat.reply_jump_back")}
        </NewMessagesButton>
    );
}
